// On DOMContentLoaded, initialize facet-related functionality
document.addEventListener('DOMContentLoaded', function () {
  onUrlChange();
  enableFacetInputs();
  bindMobileFacetsEvents();
  bindFacetsEvents();
  observeUrlChange();
});

// On DOMContentLoaded, initialize clear button and listeners for facets
window.addEventListener('DOMContentLoaded', () => {
  updateClearButtonVisibility();
  bindFacetCheckboxListeners();
  bindSlideFilterButtonListeners();
}); 

/**
 * Enables all facet input elements by removing their 'disabled' attribute.
 */
function enableFacetInputs() {
  document.querySelectorAll('.facets__item input').forEach(function (input) {
    input.removeAttribute('disabled');
  });
}

/**
 * Binds change and click events to mobile facet inputs to handle their state changes.
 */
function bindMobileFacetsEvents() {
  document.querySelectorAll('.mobile-facets__item input').forEach(function (input) {
    input.addEventListener('change', handleMobileFacetChange);
    input.addEventListener('click', handleMobileFacetChange);
  });
}

/**
 * Handles the change event for mobile facet inputs, syncing related checkboxes.
 */
function handleMobileFacetChange(e) {
  const input = e.target;
  const valuez = input.getAttribute('value');
  document.querySelectorAll('.mobile-facets__item input').forEach(function (el) {
    const datas = el.getAttribute('value');
    if (datas && datas.indexOf(',') >= 0 && datas.indexOf(valuez) >= 0) {
      if (input.checked) {
        el.checked = true;
        el.classList.add('hide-before');
      } else {
        el.checked = false;
        el.classList.remove('hide-before');
      }
    }
  });
}

/**
 * Binds change and click events to desktop facet inputs to handle their state changes.
 */
function bindFacetsEvents() {
  document.querySelectorAll('.facets__item input').forEach(function (input) {
    input.addEventListener('change', handleFacetChange);
    input.addEventListener('click', handleFacetChange);
  });
}

/**
 * Handles the change event for desktop facet inputs, syncing related checkboxes.
 */
function handleFacetChange(e) {
  const input = e.target;
  const valuez = input.getAttribute('value');
  if (input.checked) {
    document.querySelectorAll('.facets__item input').forEach(function (el) {
      const datas = el.getAttribute('value');
      if (datas && datas.indexOf(',') >= 0 && datas.indexOf(valuez) >= 0) {
        el.checked = true;
        el.classList.add('hide-before');
      }
    });
  } else {
    document.querySelectorAll('.facets__item input').forEach(function (el) {
      const datas = el.getAttribute('value');
      if (datas && datas.indexOf(valuez) >= 0) {
        el.checked = false;
        el.classList.remove('hide-before');
      }
    });
  }
}

/**
 * Observes URL changes (for /collections/ pages) and triggers facet updates when the URL changes.
 */
function observeUrlChange() {
  let lastUrl = location.href;
  if (lastUrl.indexOf('/collections/') >= 0) {
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });
  }
}

/**
 * Updates facet checkboxes and counters based on the current URL parameters.
 */
function onUrlChange() {
  const url = location.href;
  const res = url.split('&');
  let foo = 0;
  for (let i = 0; i < res.length; i++) {
    if (res[i].indexOf('concerns') >= 0 || res[i].indexOf('price') >= 0) {
      if (res[i].indexOf('%2C') <= 0) {
        const final = res[i].split('=');
        let NewFinal = decodeURIComponent(final[1]);
        NewFinal = NewFinal.replace(/\+/g, ' ');
        document.querySelectorAll('.unique_labels input').forEach(function (input) {
          const dati = input.getAttribute('value');
          if (dati && dati.indexOf(NewFinal) >= 0) {
            input.checked = true;
          }
        });
        document.querySelectorAll('.facets__item input').forEach(function (input) {
          const dati = input.getAttribute('value');
          if (dati && dati.indexOf(NewFinal) >= 0) {
            input.checked = true;
          }
        });
      }
    }
  }
  let xpp = 0;
  document.querySelectorAll('.product_filter input').forEach(function (input) {
    if (input.checked) xpp++;
  });

  document.querySelectorAll('.unique_labels input').forEach(function (input) {
    if (input.checked) foo++;
  });
  
  xpp = xpp / 2;
  foo = foo / 2;
  const counterPlace = document.querySelector('.counter_place');
  if (counterPlace) counterPlace.textContent = foo + xpp;
}

/**
 * Updates the visibility of all clear filter buttons based on whether any facet checkbox is checked.
 */
function updateClearButtonVisibility() {
  const clearButtons = document.querySelectorAll('.clear_button');
  const facetCheckboxes = document.querySelectorAll('.facets__item input[type="checkbox"]');
  const anyChecked = Array.from(facetCheckboxes).some(checkbox => checkbox.checked);

  clearButtons.forEach(button => {
    button.classList.toggle('hidden', !anyChecked);
  });
}

/**
 * Adds event listeners to all facet checkboxes to update clear button visibility on change.
 */
function bindFacetCheckboxListeners() {
  const facetCheckboxes = document.querySelectorAll('.facets__item input[type="checkbox"]');
  facetCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateClearButtonVisibility);
  });
}

/**
 * Adds click listeners to all slide filter buttons to toggle their parent's 'open' attribute.
 */
function bindSlideFilterButtonListeners() {
  const slideFilterButtons = document.querySelectorAll('.js-button__slide-filter');
  slideFilterButtons.forEach(button => {
    if (button.getAttribute('listener') !== 'true') {
      button.addEventListener('click', () => {
        if (button.parentNode) {
          button.parentNode.toggleAttribute('open');
        }
        button.setAttribute('listener', 'true');
      });
    }
  });
}